module.exports = __webpack_public_path__ + "img/snowa_logo.4382186.svg";